export const API_URL = 'https://api.escuelajs.co/api/v1';
